import React from 'react';
import { Link } from 'gatsby';
import { IArticle } from '../../../interfaces/Article.interface';
import { handleKeyAction } from '../../../utils/functions';
import './RelatedArticles.scss';

interface Props {
    data: IArticle[];
}

const RelatedArticles = ({ data }: Props) => {
    if (data.length === 0) {
        return <></>;
    }

    return (
        <div className="m-related-articles">
            <h2>Artículos relacionados</h2>
            <ul>
                {data?.map(({ url, h2 }) => (
                    <li key={url}>
                        <div className="bullet" />
                        <Link
                            to={url}
                            tabIndex={0}
                            rel="noopener noreferrer"
                            onKeyDown={(e) => handleKeyAction(e, url)}
                        >
                            {h2}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default RelatedArticles;
